export const FB_LOGIN_AND_ME = 'FB_LOGIN_AND_ME'
export const FB_LOGIN_AND_ME_LOADING = 'FB_LOGIN_AND_ME_LOADING'
export const FB_LOGIN_AND_ME_FAILURE = 'FB_LOGIN_AND_ME_FAILURE'
export const FB_LOGIN_AND_ME_SUCCESS = 'FB_LOGIN_AND_ME_SUCCESS'
export const FB_LOGIN_AND_ME_UNLOAD = 'FB_LOGIN_AND_ME_UNLOAD'

export const fbLoginAndMe = () => ({
  type: FB_LOGIN_AND_ME,
})

export const unloadFbLoginAndMe = () => ({
  type: FB_LOGIN_AND_ME_UNLOAD,
})



// WEBPACK FOOTER //
// ./src/actions/fb.js